// extracted by mini-css-extract-plugin
export default {"lootbox-reward-card__wrapper":"LootboxOpenSuccessReward_lootbox-reward-card__wrapper__CbZxL"};